<h5>{{data.head}}</h5>
<hr>
<div class="content-wrap" *ngIf="data.body">
  <b class="mb-0" [innerHtml]="data.body">
  </b>
  <p class="mb-0" [innerHtml]="data.item? data.item: ''">
  </p>
  <strong *ngIf="data.link?.length">
    <a style="display: block;" [routerLink]="['/user', 'OFFICIAL'].concat(data.link)" (click)="onNoClick()">Click
      Here</a>
  </strong>
</div>
<div *ngIf="data.isBulkUpload">
  <ng-container *ngIf="!data.hideCategory">
    <p class="my-1">You are about to upload data for following category:</p>
    <div class="hierarchy" *ngIf="getHierarchy() as hierarchy">
      <ng-container *ngFor="let item of hierarchy; let i=index">
        <mat-icon *ngIf="i>0 && i!==hierarchy.length">chevron_right</mat-icon>
        <strong>{{item}}</strong>
      </ng-container>
    </div>
  </ng-container>
  <input type="file" accept=".xls,.xlsx,.csv" class="mt-3" (change)="onSelectedFile($event)" />
  <div class="red p-1" *ngIf="error && !file">Please select a file.</div>
  <hr>
</div>
<div *ngIf="data.isReject">
  <div class="row">
    <app-textarea-field class="col-lg-12" label="Remarks" placeholder="Please Enter Remarks for Rejection"
      [control]="remark" rows="5" charCount="500">
    </app-textarea-field>
  </div>
</div>
<div *ngIf="data.hasAttachment">
  <div class="row">
    <app-textarea-field class="col-lg-12" label="Remarks" placeholder="Please Enter Remarks for Rejection"
      [control]="remark" rows="5" charCount="500">
    </app-textarea-field>
  </div>
</div>


<div class="mb-1 mt-1">
  <button mat-raised-button (click)="confirm()" [color]=" data.delete? 'warn':'primary'">
    {{ data.alert? 'OK' : data.isBulkUpload || data.isReject?'Submit': data.delete? data.btnText? data.btnText:
    'Delete': 'Yes'}}</button>
  <button mat-button (click)="onNoClick()" [color]="data.isConfirm? 'warn': 'primary'" cdkFocusInitial class="ml-2"
    *ngIf="!data.alert">{{data.isConfirm?'No':'Cancel'}}</button>
</div>